/* motion.js v3 · Vardalux motion engine.
   Consumes tokens from motion-tokens.css (source of truth).
   Vanilla + IntersectionObserver, dependency-free, Shopify-translatable 1:1
   (ships as assets/theme-motion.js, loaded with `defer`).
   Hooks: data-reveal, data-parallax, data-zoom, data-cta, data-nav-bar,
   data-nav-link, data-menu-panel, data-modal-*, data-faq-*,
   data-gallery-*. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.16,1,.3,1)';
  var STAGGER = 70;                 /* ms · 40-80 band */
  var TRAVEL = '18px';              /* fade-up distance */

  /* 1. Scroll reveals: fade-up, medium (600ms); cinematic (800ms) for first-view section only. Reveal once. */
  var revealed = new WeakSet();
  var firstSection = null;
  function dur(el) {
    if (!firstSection) firstSection = document.querySelector('[data-screen-label]');
    return firstSection && firstSection.contains(el) ? '.8s' : '.6s';
  }
  function prep(el) {
    if (reduced || revealed.has(el)) return;
    el.style.opacity = '0';
    el.style.transform = 'translateY(' + TRAVEL + ')';
    el.style.transition = 'opacity ' + dur(el) + ' ' + EASE + ', transform ' + dur(el) + ' ' + EASE;
  }
  function fire(el, delay) {
    if (revealed.has(el)) return;
    revealed.add(el);
    setTimeout(function () {
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    }, delay);
  }
  var io = new IntersectionObserver(function (entries) {
    /* group by parent: siblings stagger, unrelated elements never wait on each other */
    var groups = new Map();
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var key = e.target.parentElement || document.body;
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(e.target);
      io.unobserve(e.target);
    });
    groups.forEach(function (els) {
      els.sort(function (a, b) {
        return (+a.getAttribute('data-reveal') || 0) - (+b.getAttribute('data-reveal') || 0);
      });
      els.forEach(function (el, i) { fire(el, reduced ? 0 : i * STAGGER); });
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

  function scan() {
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      if (revealed.has(el)) return;
      prep(el);
      io.observe(el);
    });
  }

  /* 2. Hero parallax: data-parallax drifts at 0.12 ratio (transform only) */
  var px = [];
  function scanParallax() {
    px = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
  }

  /* 3. Header scroll state: refine bg/blur/border past 8px (class toggle; CSS owns the look) */
  function navState() {
    var bar = document.querySelector('[data-nav-bar]');
    if (bar) bar.classList.toggle('vlx-scrolled', window.scrollY > 8);
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      navState();
      if (!reduced && px.length) {
        var y = window.scrollY;
        px.forEach(function (el) {
          if (y < window.innerHeight * 1.5) {
            el.style.transform = 'translateY(' + (y * 0.12).toFixed(1) + 'px)';
          }
        });
      }
      ticking = false;
    });
  }, { passive: true });

  /* 4. Current-page state on nav links (aria-current drives the persistent underline) */
  function cleanPath(path) {
    if (!path || path === '/') return '/';
    return path.replace(/\/+$/, '') || '/';
  }
  function markCurrent() {
    var here = cleanPath(location.pathname);
    document.querySelectorAll('[data-nav-link]').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      var path = cleanPath(new URL(href, location.origin).pathname);
      if (path === here) a.setAttribute('aria-current', 'page');
      else a.removeAttribute('aria-current');
    });
  }

  /* 5. FAQ accordions: icon rotate; panels animate max-height inline (tokens-timed) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-faq-btn]');
    if (btn) {
      var icon = btn.querySelector('[data-faq-icon]');
      if (icon) icon.classList.toggle('vlx-open');
    }
    /* 6. Gallery crossfade: thumb click swaps main image behind a fade+blur dip */
    var th = e.target.closest('[data-gallery-thumb]');
    if (th) {
      var src = th.getAttribute('data-src');
      var srcset = th.getAttribute('data-srcset');
      var main = document.querySelector('[data-gallery-main]');
      var img = main && main.querySelector('img');
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.toggle('vlx-active', t === th); });
      if (main && img && src && img.src !== src) {
        main.classList.add('vlx-swapping');
        setTimeout(function () {
          img.src = src;
          if (srcset) img.srcset = srcset;
          else img.removeAttribute('srcset');
          img.onload = function () { main.classList.remove('vlx-swapping'); };
          setTimeout(function () { main.classList.remove('vlx-swapping'); }, 600);
        }, reduced ? 0 : 280);
      }
    }
  });

  document.addEventListener('shopify:section:load', function () {
    scan();
    scanParallax();
    markCurrent();
  });

  scan();
  scanParallax();
  navState();
  markCurrent();
})();
